const variantStockData = {};
class StockChecker {
  constructor() {
    //this.defaultLocation = 82920702235;
    //this.additionalLocation = 95968297243;
  }

  getStock(variantId) {
    const _this = this;
    return new Promise((resolve, reject) => {
      if (variantStockData[variantId]) {
        resolve(variantStockData[variantId]);
      } else {
        fetch("/apps/galazka/syncProduct", {
          method: "POST",
          body: JSON.stringify({
            vId: variantId,
          }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (json) {
            //console.log(json);
            const productData = json[0];
            if (productData.data) {
              const data = productData.data[0];
              const productStocks = {
                shopifyStock: data.shopifyStock ? data.shopifyStock : 0,
                additionalStock: data.stock ? data.stock : 0,
              };

              variantStockData[variantId] = productStocks;
              resolve({
                ...productStocks,
                vId: variantId,
                status: productData.status,
              });
            } else {
              // Do nothing
              console.log("No stock data for variant", variantId);
            }
          });
      }
    });
  }

  getStocks(variantIds) {
    return new Promise((resolve, reject) => {
      if (typeof variantIds === "string") {
        variantIds = [variantIds];
      }
      return Promise.all(
        variantIds.map((variantId) => {
          return this.getStock(variantId);
        })
      )
        .then(function (stocks) {
          resolve(stocks);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }
}

window.stockChecker = new StockChecker();

document
  .querySelectorAll(".product-card-wrapper")
  .forEach(function (productCard) {
    productCard.addEventListener("click", function (e) {
      const form = productCard.querySelector("product-form");
      if (form) {
        const variantId = form.querySelector('input[name="id"]').value;
        window.stockChecker.getStock(variantId).then(function (stock) {
          console.log(stock);
        });
      }
    });
  });
/*
document.addEventListener('mouseover', function(e) {
  console.log('mouseover', e)
  if(e.target && ( e.target.closest('.product-card-wrapper') || (e.target.classList && e.target.classList.contains('product-card-wrapper')) ) ) {
    const productCard = e.target.closest('.product-card-wrapper') || e.target
    const form = productCard.querySelector('product-form')
    console.log('product hovered', form)
    if( form ) {
      const variantId = form.querySelector('input[name="id"]').value;
      window.stockChecker.getStock(variantId).then(function(stock) {
        console.log(stock);
      });
    }
  }
});
*/
